export default "__VITE_ASSET__B7$Uo8it__"